
/*
 * 项目全部的数据请求地址，方便统一管理
 * 写法：不用写域名，直接写绝对路径
 */
export default {
	// prisonLists:'/Api/iface/HJYY/listDepts', //监区列表
	findLogin:'/Api', //统一
	familyInfo:'tyrz/info',//获取家属信息
	files:'/Api?func=upload',//上传文件
	filesDown:'/Api?func=download',//下载文件
	zd:'/Api/iface/HJYY/dict',//字典
	getToken:'tyrz/getToken'
}


// WEBPACK FOOTER //
// ./src/axios/api/api.js